import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import webDevelopment from '../../assest/web-development.jpg';
import python from '../../assest/python.jpg';
import iot from '../../assest/iot.jpg';
import './Certificate.css';

export default function Certificate() {
  return (
    <section id='certificate' className='certificates'>
      <div className='heading'>
        <h1>Certificates</h1>
      </div>
      <div className='projects'>
        <div class='card'>
          <img src={python} alt='Avatar' className='image' />
          <div class='container'>
            <h4>
              <b>Google</b>
            </h4>
            <p>Crash Course on Python</p>
            <a
              target='_blank'
              href='https://drive.google.com/file/d/12T4nrEbdwtNCeEk01-LVMNo9dNSemqXG/view?usp=drive_link'
            >
              <FaExternalLinkAlt style={{ fontSize: '1.2rem', color: 'rgba(0, 0, 0, 0.574)' }} />
            </a>
          </div>
        </div>

        <div class='card'>
          <img src={webDevelopment} alt='Avatar' className='image' />
          <div class='container'>
            <h4>
              <b>IBM</b>
            </h4>
            <p>Web Development</p>
            <a
              target='_blank'
              href='https://drive.google.com/file/d/1fn2XwLD-4mO79SdgTjEpcRRmhnbkTF6i/view?usp=sharing'
            >
              <FaExternalLinkAlt style={{ fontSize: '1.2rem', color: 'rgba(0, 0, 0, 0.574)' }} />
            </a>
          </div>
        </div>

        <div class='card'>
          <img src={iot} alt='Avatar' className='image' />
          <div class='container'>
            <h4>
              <b>NIELIT</b>
            </h4>
            <p>Internet of Things</p>
            <a
              target='_blank'
              href='https://drive.google.com/file/d/1GcHAGbTjmVnOL-trgUDXsUX9t5IyWZwn/view?usp=sharing'
            >
              <FaExternalLinkAlt style={{ fontSize: '1.2rem', color: 'rgba(0, 0, 0, 0.574)' }} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
